// extracted by mini-css-extract-plugin
export default {"bar":"CookieNotice_bar__wUVZ1","text":"CookieNotice_text__LkbYO","link":"CookieNotice_link__XTMjm","button":"CookieNotice_button__z8g0B"};